import COLOURS from '../constants/colour';
import { ApplicationType } from '../types/application';
import DataPassportLogo from '../assets/images/sejutakg-logo.svg';

const appConfig = (
  isProduction: boolean,
  authUrl: string,
  redirectUrl: string,
): ApplicationType => {
  const applicationId = isProduction ? 'tv-p-sejutakgdatapassport' : 'tv-s-sejutakgdatapassport';

  return {
    pdaAuth: {
      login: `${authUrl}/services/login?application_id=${applicationId}&redirect_uri=${encodeURIComponent(
        redirectUrl,
      )}`,
      signup: `${authUrl}/services/signup?application_id=${applicationId}&redirect_uri=${redirectUrl}`,
    },
    customerPerksLink: 'https://www.datapassport.com/malaysia-network/perks',
    merchantPerksLink: 'https://www.datapassport.com/malaysia-network/perks',
    merchantRegisterLink: 'https://www.datapassport.com/malaysia-network/merchants',
    proposeDataPassLink: '',
    applicationId,
    appName: 'SejutaKG Application',
    supportEmail: 'support@dataswift.io',
    operatorName: 'SejutaKG',
    datasourceProviderName: '27Gems',
    primaryColour: COLOURS.SejutaKGPurple,
    merchantColour: COLOURS.RoyalPurple,
    logoUrl: DataPassportLogo,
  };
};

export default appConfig;
